import { useTranslation } from "react-i18next";

const transactionCurrencyCodeOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "hkd",
      title: t("options.currencyCode.hkd"),
      value: "344",
    },
    {
      key: "usd",
      title: t("options.currencyCode.usd"),
      value: "840",
    },
    {
      key: "sgd",
      title: t("options.currencyCode.sgd"),
      value: "702",
    },
    {
      key: "eur",
      title: t("options.currencyCode.eur"),
      value: "978",
    },
    {
      key: "jpy",
      title: t("options.currencyCode.jpy"),
      value: "392",
    },
    {
      key: "gbp",
      title: t("options.currencyCode.gbp"),
      value: "826",
    },
    {
      key: "cad",
      title: t("options.currencyCode.cad"),
      value: "124",
    },
    {
      key: "aud",
      title: t("options.currencyCode.aud"),
      value: "036",
    },
    {
      key: "thb",
      title: t("options.currencyCode.thb"),
      value: "764",
    },
    {
      key: "vnd",
      title: t("options.currencyCode.vnd"),
      value: "704",
    },
    {
      key: "twd",
      title: t("options.currencyCode.twd"),
      value: "901",
    },
    {
      key: "krw",
      title: t("options.currencyCode.krw"),
      value: "410",
    },
    {
      key: "idr",
      title: t("options.currencyCode.idr"),
      value: "360",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default transactionCurrencyCodeOptions;
